import { render, staticRenderFns } from "./PlayerVideo.vue?vue&type=template&id=ba525394&scoped=true"
import script from "./PlayerVideo.vue?vue&type=script&lang=ts"
export * from "./PlayerVideo.vue?vue&type=script&lang=ts"
import style0 from "./PlayerVideo.vue?vue&type=style&index=0&id=ba525394&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba525394",
  null
  
)

export default component.exports